import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m_pa30 m_flex m_justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = ["content"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      open: _ctx.open,
      link: _ctx.link
    }),
    _createVNode(_component_BaseDialog, {
      modelValue: _ctx.modalOpened,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalOpened) = $event)),
      close: "",
      "content-width": "910px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseCard, {
          modelValue: _ctx.modalOpened,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalOpened) = $event)),
          class: "m_bg-white m_pa16 m_pt8"
        }, {
          default: _withCtx(() => [
            (_ctx.contentLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_BaseLoader, { variant: "page" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("my-shadow-content", { content: _ctx.content }, null, 8, _hoisted_3)
                ]))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}